import { render } from "./CustomizationSubmitToRetailerButton.vue?vue&type=template&id=80026e32"
import script from "./CustomizationSubmitToRetailerButton.vue?vue&type=script&lang=js"
export * from "./CustomizationSubmitToRetailerButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__